import React from 'react'
import PropTypes from 'prop-types'
import styles from './category.module.scss'

export const CategoryCard = ({ image, title, logo, text, index }) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.images}>
        <img
          alt='category-image'
          src={image}
          loading="lazy"
          className={`${styles.topImage} ${index === 0 ? styles.topImage0 : index === 1 ? styles.topImage1 : styles.topImage2}`}
        />
        <div className={styles.logoContainer}>
          {typeof logo === 'string' ? (
            <img alt='category-logo' src={logo} loading="lazy" className={styles.logo} />
          ) : (
            <div className={styles.logo}>{logo}</div>
          )}
        </div>
      </div>
      <div className={styles.bottomText}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  )
}

CategoryCard.propTypes = {
  image: PropTypes.string,
  logo: PropTypes.object,
  title: PropTypes.string,
  text: PropTypes.string,
  index: PropTypes.number
}
